/**
 * trustsy brand mark — shared logo used in the shell header, consent card,
 * and liveness chrome. Served from `/logo.png` in the verify SPA public root.
 */
interface BrandMarkProps {
  /** Accessible name when not decorative. Defaults to decorative. */
  alt?: string;
  className?: string;
  /** Pixel size (square). */
  size?: number;
}

export function BrandMark({ alt = '', className, size = 28 }: BrandMarkProps) {
  const decorative = !alt;
  return (
    <img
      src="/logo.png"
      alt={alt}
      width={size}
      height={size}
      className={className ?? 'brand-mark'}
      decoding="async"
      // Decorative marks hide from AT; named ones are real images.
      aria-hidden={decorative ? true : undefined}
    />
  );
}
